import { roleLabel } from '../derive.ts';
import type { UsersTableRow } from '../types.ts';

/**
 * Role column: what the user can do inside their customer, from the Cognito
 * RBAC group plus the property count. A value, not a control.
 *
 * The property count is part of the label — "Property Manager (3)" — never a
 * separate badge. An admin group with property assignments is a real (if
 * unintended) shape and reads "Admin (3)": the mismatch is shown, not
 * reconciled.
 */
export function RoleCell({ row }: { row: UsersTableRow }) {
  const state = row.roleState;
  return (
    <span className={state.kind === 'unknown' ? 'text-sm text-muted-foreground' : 'text-sm'}>
      {roleLabel(state)}
    </span>
  );
}
